import type { DriverStatus } from '@/features/driver/domain/enums/DriverStatus'
import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'

export class MissingDriverDocumentEntity {
  id?: number
  userId?: string
  user?: UserMiniEntity
  workingPhoneNumber?: string | null
  fullName?: string | null
  avatarImagePath?: string | null
  regionId?: number
  status?: DriverStatus
}
